(function() {
    'use strict';

    angular.module('process')
        .controller('ProductionCubeDetailsController', ProductionCubeDetailsController);

    ProductionCubeDetailsController.$inject = ['$state', '$uibModal', 'processstagePermissionsConst', 'productionCubeDataSrvc', 'productionCubeProductDataSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'searchFilterSrvc', 'previewSrvc', 'productOptionGroupDataSrvc'];

    function ProductionCubeDetailsController($state, $uibModal, processstagePermissionsConst, productionCubeDataSrvc, productionCubeProductDataSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, searchFilterSrvc, previewSrvc, productOptionGroupDataSrvc) {
        var self = this;

        self.loading = true;
        self.productionCubeData = {};
        self.checkboxSelectedProp = "$$checkboxSelected";

        self.productionCubeProductsRows = [];
        self.productionCubeProductsCols = [{
            title: 'Podgląd',
            value: 'product_file.client_file_thumbnail',
            type: 'image',
            onClick: previewSrvc.previewOrderFile,
            helpers: [{
                elementClass: 'preflight-status-icon',
                tooltip: 'product_file.preflight_status.message',
                typeClass: 'product_file.preflight_status.class'
            }]
        }, {
            title: 'ID zlecenia',
            value: 'pk',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Nr zamówienia',
            value: 'order_pk',
            type: 'number',
            orderValue: 'order__pk',
            searchable: true,
            orderable: true
        }, {
            title: 'Nr montażu',
            value: 'montage_pk',
            type: 'number',
            orderValue: 'montage__pk',
            searchable: true,
            orderable: true
        }, {
            title: 'ID produktu',
            value: 'product_pk',
            type: 'number',
            orderValue: 'product__pk',
            searchable: true,
            orderable: true
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text',
            orderValue: 'product__name',
            searchable: true,
            orderable: true
        }, {
            title: 'Nakład',
            value: 'selected_quantity',
            type: 'number',
            orderValue: 'selected_quantity__quantity',
            searchable: true,
            orderable: true
        }, {
            title: 'Format',
            value: 'product_format',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Termin realizacji',
            value: 'order_realization_date',
            type: 'date',
            orderValue: 'order__realization_date',
            searchable: true,
            orderable: true
        }, {
            title: 'Następny proces',
            value: 'next_process_stage_with_count',
            type: 'text'
        }];

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.summaryCols = {
            'selected_quantity': 'selected_quantity'
        };
        self.searchQuery = {
            pk: null,
            order_pk: null,
            montage_pk: null,
            product_pk: null,
            product_name: null,
            selected_quantity: null,
            product_format: null,
            order_realization_date: null,
            ordering: null
        };

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.onOptionsGroupFilter = onOptionsGroupFilter;

        self.modelPermissions = processstagePermissionsConst;
        self.optionsGroupFilter = [];
        self.optionsGroupFilterData = {};
        self.options_pks = [];

        self.extraActions = [{
            class: 'btn btn-primary btn-xs',
            iconClass: 'glyphicon glyphicon-list-alt',
            onClick: toRealization,
            title: 'Do realizacji'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientFile,
            isDisabled: previewSrvc.isClientFileNotAvailable,
            withLoading: true,
            title: 'Plik klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getResultFile,
            isDisabled: previewSrvc.isResultFileNotAvailable,
            withLoading: true,
            title: 'Plik wyjściowy'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientCoverFile,
            isDisabled: previewSrvc.isClientCoverFileNotAvailable,
            displayCondition: previewSrvc.isClientCoverFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getCoverResultFile,
            isDisabled: previewSrvc.isCoverResultFileNotAvailable,
            displayCondition: previewSrvc.isCoverResultFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki wyjściowy'
        }];

        activate();
        // productionCubeProductFilterOptionsGroup

        function activate() {
            getProductionCube();
            getProductionCubeProductsRows();
            getProductionCubeProductLeftFilterOptionsGroup();
        }

        function getProductionCube() {
            return productionCubeDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.productionCubeData = response;

                delete self.productionCubeData.date_modified;
                delete self.productionCubeData.date_added;
                return response;
            });
        }

        function getProductionCubeProductsRows(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    production_cube_pk: $state.params.pk,

                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    id: self.searchQuery.pk,
                    order_pk: self.searchQuery.order_pk,
                    montage_pk: self.searchQuery.montage_pk,
                    product_pk: self.searchQuery.product_pk,
                    product_name: self.searchQuery.product_name,
                    selected_quantity: self.searchQuery.selected_quantity,
                    product_format: self.searchQuery.product_format,
                    order_realization_date: searchFilterSrvc.getDateValue(self.searchQuery.order_realization_date),
                    options_pks: self.options_pks,
                    ordering: self.searchQuery.ordering
                };
            }
            return productionCubeProductDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.productionCubeProductsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getProductionCubeProductsRows);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getProductionCubeProductLeftFilterOptionsGroup() {
            productOptionGroupDataSrvc.productionCubeProductFilterOptionsGroup({
                production_cube: $state.params.pk
            }).$promise.then(function(response) {
                self.optionsGroupFilter = response;
            });
        }

        function onOptionsGroupFilter() {
            var options_pks = [];
            for (var key in self.optionsGroupFilterData) {
                options_pks.push.apply(options_pks, self.optionsGroupFilterData[key]);
            }
            self.options_pks = options_pks;

            return getProductionCubeProductsRows();
        }

        function pageChange() {
            return getProductionCubeProductsRows();
        }

        function onSearchQueryChange() {
            return getProductionCubeProductsRows();
        }

        function getSelectedToRelization() {
            var selected = [];

            for (var i = 0; i < self.productionCubeProductsRows.length; i++) {
                if (self.productionCubeProductsRows[i][self.checkboxSelectedProp]) {
                    self.productionCubeProductsRows[i][self.checkboxSelectedProp] = false;
                    selected.push(self.productionCubeProductsRows[i]);
                }
            }

            return selected;
        }

        function toRealization(row) {
            $uibModal.open({
                templateUrl: 'app/process/views/production-cube-realization/production-cube-realization.html',
                controller: 'ProductionCubeRealizationController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'production-cube-realization',
                resolve: {
                    productionCube: function() {
                        return self.productionCubeData;
                    },
                    productToRealizationPks: function() {
                        var rows = getSelectedToRelization();
                        return rows.length ? rows.map(function(item) {
                            return item.pk;
                        }) : [row.pk];
                    }
                }
            }).closed.then(function() {
                if (self.productionCubeData.isStatusFinished) {
                    getProductionCube();
                    getProductionCubeProductsRows();
                }
            });
        }
    }
})();
